import { render, staticRenderFns } from "./ReviewerInfo.vue?vue&type=template&id=352b7a11&scoped=true&"
import script from "./ReviewerInfo.vue?vue&type=script&lang=js&"
export * from "./ReviewerInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerInfo.vue?vue&type=style&index=0&id=352b7a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b7a11",
  null
  
)

export default component.exports